import { useQuery } from "react-query";
import { getOfficeImageSection } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeImageSection = () => {
  return useQuery("OfficeImageSection", getOfficeImageSection, {
    refetchOnWindowFocus: false,
  });
};
